import script from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"

import "./MovesPage.vue?vue&type=style&index=0&id=a7637e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7637e24"]])

export default __exports__